// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import TmallSvg from '@rsuite/icon-font/lib/platform/Tmall';
var Tmall = createSvgIcon({
  as: TmallSvg,
  ariaLabel: 'tmall',
  category: 'platform',
  displayName: 'Tmall'
});
export default Tmall;